// ---------------------------------------------------------------------------
// Which Design screen the left rail is asking for.
//
// The rail's Canvas / Tokens / Components entries all resolve to the same
// surface id, so before this resolver existed the rail highlighted a new icon
// while the page below kept rendering the canvas. The mapping is intentionally
// closed: anything the rail has not explicitly asked for falls back to Canvas,
// which is the domain's landing screen.
// ---------------------------------------------------------------------------

export type OpenPencilDesignView = "canvas" | "tokens" | "components";

/** Authority task ids (see `studio-authority-workspaces.ts`) → design screen. */
const VIEW_BY_AUTHORITY_TASK: Record<string, OpenPencilDesignView> = {
  sources: "canvas",
  system: "tokens",
  components: "components",
};

export function resolveOpenPencilDesignView(context: {
  authorityDomain?: string | undefined;
  authorityView?: string | undefined;
}): OpenPencilDesignView {
  if (context.authorityDomain !== "design") return "canvas";
  const view = context.authorityView;
  if (!view) return "canvas";
  return VIEW_BY_AUTHORITY_TASK[view] ?? "canvas";
}
